import { usei18n } from '../i18n/i18n.js';
import { useLanguage } from '../context/LanguageContext.js';
import Modal from './Modal.js';
import './UpdateAvailableModal.css';

const UpdateAvailableModal = ({ onReload, onClose }) => {
    const { language } = useLanguage();
    const i18n = usei18n(language);
    return (
        <Modal onClose={onClose} onBackdropClick={onClose} id="update-available">
            <p className="update-message">{i18n('modal.update.message')}</p>
            <button className="update-button reload" onClick={onReload}>{i18n('modal.update.reload')}</button>
        </Modal>
    );
};

export default UpdateAvailableModal;
